import React from "react";
import { IconShape } from "./icons";

export default function RoundSteelPreview({ finish, petName, phone, addr, extra, view = "front", t, icon, design, font }) {
  const label = (petName || "ANIMAUX TAGS").toUpperCase();
  const compact = label.length > 10;
  const backLines = [phone, addr, extra].filter(Boolean);
  const showBack = view === "back";
  const hasIcon = icon && icon !== "none";
  const hasDesign = design && design !== "none";

  return (
    <div className="round-preview-pro pro-config-preview">
      <div className={`pro-round-medal flip-stage ${finish === "oro" ? "gold" : "silver"} ${showBack ? "is-flipped" : ""}`}>
        <div className="flip-inner">
          <div className="flip-face flip-front">
            <div className="pro-round-hole" />
            
            <div className="pro-round-inner">
              <div 
                className={compact ? "pro-round-name compact" : "pro-round-name"}
                style={{ fontFamily: font }}
              >
                {hasIcon && (
                  <span className="pro-round-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" width="36" height="36">
                      <IconShape kind={icon} color="#222" strokeWidth={2.4} />
                    </svg>
                  </span>
                )}
                <span>{label}</span>
              </div>
            </div>
            <div className="pro-round-shine" />
            <div className="pro-round-rim" />
          </div>

          <div className="flip-face flip-back">
            <div className="pro-round-hole" />
            <div className="pro-round-inner">
              <div className="pro-round-back-text">
                {(backLines.length ? backLines : ["514-000-0000", "INFO EXTRA"]).map((line, index) => (
                  <span key={`${line}-${index}`}>{line}</span>
                ))}
              </div>
            </div>
            <div className="pro-round-shine" />
            <div className="pro-round-rim" />
          </div>
        </div>
      </div>

      <div className="round-specs pro-specs">
        <span>{t?.spec_size || "30 mm"}</span>
        <span>{t?.spec_material || "Acier inoxydable"}</span>
        <span>{finish === "oro" ? (t?.spec_finish_gold || "Or") : (t?.spec_finish_silver || "Argent")}</span>
      </div>

      <div className="pro-price-line">
        <strong>{t?.round_price_label || "$18.99 CAD"}</strong>
        <small>{t?.round_shipping_label || "Free shipping included"}</small>
      </div>
    </div>
  );
}
